/**
 * Project: xpenser-client
 * FilePath: /src/app/common/helpers/cookie.ts
 * File: cookie.ts
 * Created Date: Friday, September 18th 2020, 12:34:20 pm
 * Author: Craig Bojko (craig@pixelventures.co.uk)
 * -----
 * Last Modified: Fri Sep 18 2020
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2020 Pixel Ventures Ltd.
 * ------------------------------------
 */

export function getCookie (name: string) {
  function escape(s: string) { return s.replace(/([.*+?^$(){}|[\]/\\])/g, '\\$1') }
  var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'))
  return match ? match[1] : null
}

export default {
  getCookie
}
